// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1YZj2","icon":"SortAdornment_icon__P5uQg","up":"SortAdornment_up__3-1jB","down":"SortAdornment_down__1uPq3","active":"SortAdornment_active__3e01E"};